import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { IDataSourceInfo } from '~src/datasource/models/IDataSourceInfo';
import { extractFailureNotificationOptInRequest, extractFailureNotificationOptOutRequest } from '~src/extractTask/actions/ExtractFailureNotificationActions';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { anyItemIsEmbeddedDatasource } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { selectSpaceInfo } from '~src/spacesPlatform/selectors/SpaceInfoSelectors';
import { SpaceInfo } from '~src/spacesPlatform/state/SpaceInfo';
import { currentUserIsOwnerOrAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';
import { IWorkbookInfo } from '~src/workbook/models/IWorkbookInfo';

import { AppState } from '../../../bootstrap/redux/state/AppState';
import { Messages } from '../../../codegen/Localize';
import { IExtractFailureNotificationActions } from '../../../spacesPlatform/models/actionNames';

const userIsOptedOut = (availableActions: IExtractFailureNotificationActions, targetItems: IWorkbookInfo[] | IDataSourceInfo[], state: AppState) => {
  return targetItems[0].hasExtracts && !!(availableActions && !availableActions.isExtractFailureNotificationEnabled);
};

const userIsOptedIn = (availableActions: IExtractFailureNotificationActions, targetItems: IWorkbookInfo[] | IDataSourceInfo[], state: AppState) => {
  return targetItems[0].hasExtracts && !!(availableActions && availableActions.isExtractFailureNotificationEnabled);
};

export const ExtractFailureNotifiationEntityMenu: IEntityAction<IWorkbookInfo | IDataSourceInfo, IExtractFailureNotificationActions> = {
  name: EntityActionNames.ExtractFailureNotification,
  translateName: Messages.extractFailureNotification,
  isVisible: (targetItems: IWorkbookInfo[] | IDataSourceInfo[], state: AppState) => {
    const spaceInfo: SpaceInfo = selectSpaceInfo(state);
    if (spaceInfo.item.contentType === 'workbook'){
      return FeatureFlags.allowNonAdminRefreshExtractNotificationsEnabled && !anyItemIsEmbeddedDatasource(targetItems) && !currentUserIsOwnerOrAdmin(state, spaceInfo.item);
    }
    return false;
  },
  isClickable: (availableActions: IExtractFailureNotificationActions, targetItems: IWorkbookInfo[] | IDataSourceInfo[], state: AppState) => {
    return targetItems[0].hasExtracts;
  },
  createReduxAction: () => null
};

export const ExtractFailureNotifiationOptInEntityAction: IEntityAction<IWorkbookInfo | IDataSourceInfo, IExtractFailureNotificationActions> = {
  name: EntityActionNames.ExtractFailureNotificationOptIn,
  translateName: Messages.yes,
  isVisible: (targetItems: IWorkbookInfo[] | IDataSourceInfo[]) => {
    return FeatureFlags.allowNonAdminRefreshExtractNotificationsEnabled;
  },
  isClickable: userIsOptedOut,
  isChecked: userIsOptedIn,
  createReduxAction: (targetItems) =>
    extractFailureNotificationOptInRequest(targetItems[0].contentType === 'workbook'? targetItems[0].id : targetItems[0].idForFavoriting, targetItems[0].contentType)
};


export const ExtractFailureNotifiationOptOutEntityAction: IEntityAction<IWorkbookInfo | IDataSourceInfo, IExtractFailureNotificationActions> = {
  name: EntityActionNames.ExtractFailureNotificationOptOut,
  translateName: Messages.no,
  isVisible: (targetItems: IWorkbookInfo[] | IDataSourceInfo[]) => {
    return FeatureFlags.allowNonAdminRefreshExtractNotificationsEnabled;
  },
  isClickable: userIsOptedIn,
  isChecked: userIsOptedOut,
  createReduxAction: (targetItems) =>
    extractFailureNotificationOptOutRequest(targetItems[0].contentType === 'workbook'? targetItems[0].id : targetItems[0].idForFavoriting, targetItems[0].contentType)
};